import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import ClassNames from 'classnames';
import LinkedInSvg from '@src/svgs/linkedin.svg';
import LinkedInInactiveSvg from '@src/svgs/linkedin-inactive.svg';
import { Props } from './props';
import './styles.scss';

export const LinkedIn: FC<Props> = ({ linkedInUrl, isRedirectedManually, wrapperClassName, onClick, label }) => {
  return (
    <div
      className={ClassNames('linkedin-button', wrapperClassName, {
        'linkedin-button--disabled': !linkedInUrl && !isRedirectedManually,
      })}
    >
      <a href={linkedInUrl || '#'} onClick={onClick} target="_blank">
        <span>{label || 'View'} </span>

        <Svg src={linkedInUrl || isRedirectedManually ? LinkedInSvg : LinkedInInactiveSvg} />
      </a>
    </div>
  );
};
